import { createFileRoute } from "@tanstack/react-router"

import { SiftListDetailView } from "@/features/sift/components/sift-list-detail-view"
import { siftListQueryOptions } from "@/features/sift/hooks/use-sift"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/sift/lists/$id")({
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient }, params }) =>
    warm(queryClient, [
      siftListQueryOptions(params.id),
    ]),
  component: SiftListDetailRoute,
})

function SiftListDetailRoute() {
  const { id } = Route.useParams()
  // Keyed by id so filter state resets when switching lists.
  return <SiftListDetailView key={id} id={id} />
}
